module.exports = __webpack_public_path__ + "static/media/lock.0d2feaaa.svg";